import type { MouseEvent } from 'react';

/**
 * Jim 2026-10-21: "everything has a date format, I want to click on it" — a
 * native date box opens its calendar from anywhere in the field, not only
 * the browser's tiny indicator. Falls back to focus where showPicker is
 * missing or refused (some WebViews).
 */
export function openDatePicker(e: MouseEvent<HTMLInputElement>) {
  const input = e.currentTarget;
  try {
    if (typeof input.showPicker === 'function') {
      input.showPicker();
      return;
    }
  } catch {
    /* needs a user gesture or is cross-origin: fall through */
  }
  input.focus();
}
